import classNames from 'classnames'
import { ReactElement, ReactNode } from 'react'
import styles from './index.module.css'

interface Props {
  className?: string
  children: ReactNode
}

export function SubTabList(props: Props): ReactElement {
  return <ul className={classNames(styles.tabList, props.className)}>{props.children}</ul>
}
